import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { Amount } from "app/components/ui/Amount/Amount";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import "./DiscountedPriceSection.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const DiscountedPriceSection = ({
	percentage = 0,
	net = 0,
	discounted = 0,
	typographySize,
	isBold = true,
	shouldDisplaySuffix = true,
	suffixSize = "small",
	priceFirst = false,
}) => {
	if (discounted === 0) {
		return null;
	}

	const containerClassName = classNames({
		"discounted-price-section": true,
		"discounted-price-section--price-first": priceFirst,
	});

	const suffix = shouldDisplaySuffix && (
		<>
			/<FormattedMessage id={"general.night.label"} />
		</>
	);

	return (
		<div className={containerClassName}>
			{percentage !== 0 && (
				<Typography
					className="discounted-price-section__discount-percentage"
					data-testid="discount-percentage"
					variant={TYPOGRAPHY_VARIANTS.SMALL}
					component="p"
				>
					-{percentage}%
				</Typography>
			)}
			{discounted !== net && (
				<Typography
					className="discounted-price-section__initial-price"
					variant={TYPOGRAPHY_VARIANTS.SMALL}
					component="p"
				>
					<Amount
						value={net}
						size="small"
						isBold={false}
						className="discounted-price-section__initial-amount"
					/>
				</Typography>
			)}

			<Amount
				value={discounted}
				size={typographySize}
				isBold={isBold}
				suffix={suffix}
				suffixSize={suffixSize}
			/>
		</div>
	);
};

DiscountedPriceSection.propTypes = {
	typographySize: PropTypes.string,
	isBold: PropTypes.bool,
	shouldDisplaySuffix: PropTypes.bool,
	suffixSize: PropTypes.string,
	percentage: PropTypes.number,
	net: PropTypes.number,
	discounted: PropTypes.number,
	priceFirst: PropTypes.bool,
};

export default memo(DiscountedPriceSection);
